var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "dateRange",
    attrs: {
      id: "dateRange"
    }
  }, [_c("a-input-group", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      compact: ""
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      flex: "1 1 42.5%",
      "min-width": "auto"
    },
    attrs: {
      allowClear: _vm.allowClear,
      value: _vm.dateRange.startDateClone,
      "disabled-date": _vm.disabledStartDate,
      format: _vm.dateformatvalue,
      placeholder: this.$t("publicuse.starttime"),
      dateformat: _vm.dateformat,
      "show-time": _vm.showTime
    },
    on: {
      change: _vm.changeStartDate
    }
  }, [_c("span", {
    attrs: {
      slot: "suffixIcon"
    },
    slot: "suffixIcon"
  })]), _c("a-input", {
    staticStyle: {
      "min-width": "40px",
      flex: "1 1 15%",
      "border-left": "0",
      "pointer-events": "none",
      backgroundColor: "#fff"
    },
    attrs: {
      placeholder: "~",
      disabled: ""
    }
  }), _c("a-date-picker", {
    staticClass: "inputGroupOfRight",
    staticStyle: {
      flex: "1 1 42.5%",
      "min-width": "auto"
    },
    attrs: {
      allowClear: _vm.allowClear,
      "disabled-date": _vm.disabledEndDate,
      format: _vm.dateformatvalue,
      dateformat: _vm.dateformat,
      placeholder: this.$t("publicuse.endtime"),
      "show-time": _vm.showTime
    },
    on: {
      change: _vm.changeEndDate
    },
    model: {
      value: _vm.dateRange.endDateClone,
      callback: function callback($$v) {
        _vm.$set(_vm.dateRange, "endDateClone", $$v);
      },
      expression: "dateRange.endDateClone"
    }
  }, [_c("span", {
    attrs: {
      slot: "suffixIcon"
    },
    slot: "suffixIcon"
  })])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };